import { Map } from "immutable";
import { isFilterPeriod } from "./region_and_date_filter";
export const setFilterParam = (key, value, history)=>{
    let params = getCurrentFilterParams(true, history.location.search);
    params = value && value != "" ? params.set(key, value) : params.remove(key);
    const pathname = history.location.pathname;
    let query = createFilterQuery(params);
    history.push(`${pathname}${query}`);
};
export const createFilterQuery = (filterParams)=>{
    if (filterParams.isEmpty()) return '';
    const params = filterParams.mapEntries((param)=>{
        let [key, value] = param;
        return [
            key,
            value
        ];
    }).toArray();
    let search = new URLSearchParams(params);
    return `?${search.toString()}`;
};
export const getCurrentFilterParams = function() {
    let allowDate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, search = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : window.location.search;
    let params = new URLSearchParams(search);
    let filterParams = Map();
    params.forEach((value, key)=>{
        if (key == 'waar' || key == 'categorie') {
            filterParams = filterParams.set(key, value);
        }
        if (key == 'wanneer' && (allowDate || isFilterPeriod(value))) {
            filterParams = filterParams.set(key, value);
        }
    });
    return filterParams;
};
/**
 * Activity detail pages do not handle dates in the `wanneer` parameter.
 * The optional `allowDate` param allows us to hide it from a link.
 * @param {boolean} allowDate - allow a specific date as 'wanneer' parameter
 */ export const getCurrentFilterQuery = function() {
    let allowDate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return createFilterQuery(getCurrentFilterParams(allowDate));
};
